import React from "react";

import AddIcon from "@mui/icons-material/Add";
import FormDialog from "../../../../components/Dialog/FormDialog";
import InviteUserForm from "./InviteUserForm";
import UploadUserCSV from "./uploadUserCSV/UploadUserCSV";
import { CustomButton } from "../../../../components/Button/Button";
import { useInviteUserDialog } from "../hooks/useInviteUserDialog";

function InviteUser() {
  const {
    handleClickOpen,
    handleClose,
    handleCloseUploadUserCSV,
    handleOpenUploadUserCSV,
    openInviteUserDialog,
    openUploadUserCSVDialog,
  } = useInviteUserDialog();
  
  return (
    <div className="mr-2">
      {openInviteUserDialog && (
        <FormDialog
          open={openInviteUserDialog}
          handleClose={handleClose}
          title={"Invite User"}
          width={"640px"}
          btnTitle={"Add"}
          fullWidth={true}
        >
          <InviteUserForm
            onClose={handleClose}
            onOpenUploadUserCSV={handleOpenUploadUserCSV}
          />
        </FormDialog>
      )}
      {openUploadUserCSVDialog && (
        <UploadUserCSV
          open={openUploadUserCSVDialog}
          onClose={handleCloseUploadUserCSV}
        />
      )}
      <CustomButton
        onClick={handleClickOpen}
        className="capitalize orange-color invite-user-button"
        variant="contained"
        startIcon={<AddIcon />}
      >
        Invite User
      </CustomButton>
    </div>
  );
}

export default React.memo(InviteUser);
